import { useEffect } from 'react';
import { useCookieConsent } from '@/contexts/CookieConsentContext';

const APOLLO_APP_ID = '69e46c922167ad00197ddb37';
const SCRIPT_ID = 'apollo-website-tracker';

declare global {
  interface Window {
    trackingFunctions?: {
      onLoad: (opts: { appId: string }) => void;
    };
  }
}

export const useApolloTracker = () => {
  const { cookiePreferences, hasConsent } = useCookieConsent();

  useEffect(() => {
    if (!hasConsent || !cookiePreferences.marketing) return;
    if (document.getElementById(SCRIPT_ID)) return;

    const nocache = Math.random().toString(36).substring(7);
    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = `https://assets.apollo.io/micro/website-tracker/tracker.iife.js?nocache=${nocache}`;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      window.trackingFunctions?.onLoad({ appId: APOLLO_APP_ID });
    };
    document.head.appendChild(script);
  }, [hasConsent, cookiePreferences.marketing]);
};
